import { compose } from 'redux'
import { connect } from 'react-redux'
import getData from '../../../functions/getData'
import { UI_GENERAL, PROGRAM_ERROR, PROGRAM_STATUS } from '../../../constants/state'
import RequestOverlay from '../presentational/RequestOverlay'
import { uiRequestOverlayReset } from '../../../actions'
import requestStatus from '../../../constants/requestStatus'
import toJS from '../../../hoc/toJS'


const statusDefault = {
    pending: false,
    error: false,
    success: false
}

const setStatus = type => type ? ({
    ...statusDefault,
    [type]: true
}) : ({
    ...statusDefault
})

const getStatus = programStatus => {
    switch(programStatus) {
        case requestStatus.REQUEST_PENDING:
            return setStatus('pending')
        case requestStatus.REQUEST_SUCCESS:
            return setStatus('success')
        case requestStatus.REQUEST_ERROR:
            return setStatus('error')
        default:
            return setStatus(false)
    }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
    onResetRequestOverlay: () => {
        dispatch(uiRequestOverlayReset())
    }
})

const mapStateToProps = (state, ownProps) => ({
    status: ownProps.programStatus ? getStatus(ownProps.programStatus) : getStatus(getData(state, PROGRAM_STATUS)),
    error: ownProps.programError ? ownProps.programError : getData(state, PROGRAM_ERROR),
    uiRequestOverlay: getData(state, [UI_GENERAL, 'requestOverlay'])
})



export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    toJS()
)(RequestOverlay)